import store from '../store'
function level1Path (route) {
  return route.path.substring(1).split('/')[0]
}
const whiteRoute = ['/cyCrkManage/detail', '/ycdeliveryOrder/detail', '/productrecord/detail', '/deliveryOrder/detail']
function validateSystemRoute (fromPath, toPath) {
  if (fromPath.split('/').length !== toPath.split('/').length) {
    return false
  }
  return true
}

export default {
  beforeRouteLeave (to, from, next) {
    const fromss = level1Path(from)
    const toss = level1Path(to)
    const toPath = to.path.split('?')[0]
    if ((fromss !== toss || (fromss === 'system' && validateSystemRoute(from.path, toPath))) && whiteRoute.indexOf(toPath) === -1) {
      store.commit('removeKeepAlive', this.$options.name)
    }
    next()
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      store.commit('addKeepAlive', vm.$options.name)
    })
  },
  activated () {
    if (this.initData) {
      this.initData()
    } else {
      this.$options.created.forEach(fun => {
        fun.call(this)
      })
    }
  }
}
